
export const ASSESSMENT_BASE_URL = process.env.REACT_APP_ASSESSMENT_BASE_URL || "https://uat.apt.excoleadership.com/assessment"

export const ADMIN_VERSION = process.env.REACT_APP_ADMIN_VERSION || "V0.0.1"

export const ADMIN_CUSTOM_TEXT = process.env.REACT_APP_ADMIN_CUSTOM_TEXT || "Testing"

export const STATIC_IMAGE = process.env.REACT_APP_STATIC_IMAGE || "https://static.ouraipro.com"

